import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import * as actionTypes from '@actionTypes';
import * as actions from '@actions';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { SessionForm } from '@components/Clinicians/session-form';
import { useSessionFormState } from '@hooks/useSessionFormState';

const useSessionFlagMutation = ({ field }: { field: keyof SessionForm }) => {
  const {
    appointment: { appointment_id, appointment_completed: isCompleted, clinician_user_guid },
    refetchAppointment
  } = useSessionAppointment();

  const dispatch = useDispatch();
  const [, setField] = useSessionFormState(field);

  return useMutation({
    mutationKey: ['clinicianFlagsPost', appointment_id, clinician_user_guid],
    mutationFn: async ({ field, value }: { field: keyof SessionForm; value: boolean }) => {
      if (isCompleted) return;

      const response = await dispatch(
        actions.clinicianFlagsPost({
          p_user_guid: clinician_user_guid,
          appt_id: appointment_id,
          [field]: value
        })
      );

      if (response.type !== actionTypes.ACTION_SUCCESS) {
        // Manually throw error
        const error = await response?.error?.json();
        throw new Error(error?.message || 'Unknown Error');
      }
    },
    onSuccess(_, { value }) {
      setField(value);
      refetchAppointment();
    }
  });
};

export default useSessionFlagMutation;
